import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/pro-regular-svg-icons';

interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}

const FAQItem: React.FC<FAQItemProps> = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="mb-4 rounded-lg bg-base-200">
      <button onClick={onClick} className="flex w-full items-center justify-between p-4 text-left">
        <span className="text-xl font-medium">{question}</span>
        <span>
          <FontAwesomeIcon className="text-base text-primary opacity-50" icon={isOpen ? faChevronUp : faChevronDown} />
        </span>
      </button>
      {isOpen && <div className="p-4 text-left text-base">{answer}</div>}
    </div>
  );
};

export default FAQItem;
